import getRequest from '../../../../getRequest';

/**
 * Get a list of the attributes .
 *
 * @param {number} siteId
 * @param {number} productAttributeDefId
 * @param {number} languageId
 * @returns Attributes
 */
export default function getSiteAttributes(siteId, languageId) {
  const query = languageId ? `?LanguageId=${languageId}` : '';
  const endpoint = `/oc-product/v1/sites/${siteId}/single-multi-attributes/${query}`;

  return new Promise((resolve, reject) => {
    getRequest(endpoint, 'Get Attributes')
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
}
